// extracted by mini-css-extract-plugin
export default {"container":"dialog_container__2YEtI","inner":"dialog_inner__RxVpG","close":"dialog_close__3yQVY","content":"dialog_content__28Qr9"};